<template>
    <div>
        <ssam-talk-write-link
            v-for="writeLayout in writeLayouts"
            :key="`ssams${writeLayout}`"
            :writeLayout="writeLayout"
            :ssam-talk-data="ssamTalkStepData"
        ></ssam-talk-write-link>
    </div>
</template>

<script>
import SsamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
import SsamTalkWriteLink from "@/components/ssamtalk/link/SsamTalkWriteLink.vue";
import alertMixins from "@/mixins/alertMixins";
import ssamTalkValidator from "@/components/ssamtalk/ssamTalkValidator";
import DeleteClass from "@/mixins/deleteClass";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import elFileMixins from "@/mixins/elFileMixins";
import {getTTSWavFile} from "@/components/ssamtalk/lib/googleCloudTTS";

export default {
    name: "SsamTalkStepWriteComponent",
    mixins: [SsamtalkUtil, ssamTalkValidator, alertMixins, elFileMixins],
    components: {
        SsamTalkWriteLink,
    },
    provide() {
        return {
            ssamTalkWriteSetData: this.setData,
        }
    },
    props: {
        ssamTalkType: {type: String, default: ""},
        ssamTalkKey: {type: Number, default: 0},
        ssamTalkStepKey: {type: Number, default: 0},
        viewAfterFunc: {type: Function, default: () => {}},
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            writeLayouts: [],
            writeFunc: "",
            writeApiParamSet: {},
            fileType: "",
            directUrl: "",
            directType: "",
            writeSuccessType: 1,
            writeFailTypes: {},
            deleteKeyName: "",
            deleteFunc: "",
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},

            ssamTalkStepData: {},
            isRunning: false,
            beforeSetKorean: '',
        }
    },
    created() {
        this.initConfig();
        if (this.ssamTalkStepKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getSsamTalkStep();
        }
    },
    mounted() {
        EventBus.$on('writeSsamTalkStep', this.writeSsamTalkStep)
        EventBus.$on("deleteSsamTalkStep", this.runDeleteConfirm);
    },
    beforeDestroy() {
        EventBus.$off('writeSsamTalkStep')
        EventBus.$off("deleteSsamTalkStep");
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnSsamTalkConfig(this.ssamTalkType);
            this.writeLayouts = config.writeLayouts;
        },
        initConfig() {
            let config = this.returnSsamTalkConfig(this.ssamTalkType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.fileType = config.fileType;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.deleteKeyName = config.deleteKeyName;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.newDeleteClass();
        },
        getSsamTalkStep() {
            EventBus.$emit('apiLoading', true);
            let params = Object.assign({}, this.detailApiParamSet);
            params.ssid = this.ssamTalkStepKey;
            try {
                this.$api.$ssamtalk[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type == -1 || res.List.length == 0) {
                        this.errorAlert('데이터를 불러울수가 없습니다.');
                        if(this.directType == 'modal') {
                            this.$modal.hide(this.directUrl);
                        }else{
                            this.$router.back();
                        }
                        return;
                    }
                    this.ssamTalkStepData = res.List[0];
                    this.initTemplateConfig();
                    EventBus.$emit('apiLoading', false);
                })
            }catch (e) {
                console.log(e)
            }

        },
        _checkValidator() {
            let validatorArr = ['stepSeq', 'talkKorean'];

            return this.$validate(validatorArr).then((success) => {
                if (!success) {
                    this.errorAlert("필수데이터를 확인해주세요.");
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success;
                }
                return success;
            });
        },
        _makeParams() {
            let params = {
                type: 'step',
                s_idx: this.ssamTalkKey,
                ss_type: 1,
                ss_seq: this.stepSeq,
                editor: [
                    {
                        sse_sentence_ko: this.talkKorean,
                        sse_sentence_en: this.talkEnglish,
                        sse_sentence_cn: '',
                    }
                ],
            }
            if(this.ssamTalkStepKey != 0) {
                params.ss_idx = this.ssamTalkStepKey;
            }
            if(this.stepSeq == this.ssamTalkStepData.ss_seq) {
                delete params.ss_seq;
            }
            return params;
        },
        returnWriteType(type) {
            if (type === this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? "저장 실패했습니다." : this.writeFailTypes[type];
            }
        },
        async writeSsamTalkStep() {
            if(this.isRunning) {
                return;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if(!validator) {
                this.isRunning = false;
                return;
            }
            EventBus.$emit('apiLoading',true);
            let params = this._makeParams();
            try {
                this.$api.$ssamtalk[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.type);
                    if (type !== true) {
                        this.errorAlert(type);
                        EventBus.$emit("apiLoading", false);
                        this.isRunning = false
                        return;
                    }
                    let key = this.ssamTalkStepKey > 0 ? this.ssamTalkStepKey : Number(res.List)
                    this.uploadTTSFile(key)
                })
            }catch (e) {
                console.log(e);
                this.errorAlert('저장에 실패하였습니다.');
                EventBus.$emit('apiLoading',false);
            }
        },
        async uploadTTSFile(key) {
            if(this.beforeSetKorean != '' && this.beforeSetKorean == this.talkKorean) {
                this.afterFunc(key);
                return;
            }
            let wavFile = await getTTSWavFile(this.talkKorean);
            this.speakTTSFile.push({raw: wavFile, name: wavFile.name, url: '', org_url: '', size: wavFile.size, });
            this.uploadFiles(this.speakTTSFile, 'ssamtalk_step', key).then(res => {
                this.afterFunc(key);
            })
        },
        afterFunc(key) {
            EventBus.$emit("apiLoading", false);
            let content = "저장되었습니다.";
            this.viewAfterFunc();
            this.createAlert({
                content: content,
                hide: () => {
                    if (this.directType === "back") {
                        this.$router.back();
                        EventBus.$emit("apiLoading", false);
                        return false;
                    }
                    if (this.directUrl === "") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit("apiLoading", false);
                        this.getSsamTalkStep();
                        return false;
                    }
                    if (this.directType === "detail") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit("apiLoading", false);
                        let url = this.directUrl + key;
                        this.$router.push(url);
                        return false;
                    }
                    if (this.directType === "modal") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit('getDetail')
                        EventBus.$emit("apiLoading", false);
                        this.$modal.hide(this.directUrl);
                        return false;
                    }
                    EventBus.$emit("apiLoading", false);
                    let url = this.directUrl;
                    this.$router.push(url);
                },
            });
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$ssamtalk[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm() {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirmText: "삭제",
                confirm: () => {
                    this.runDelete();
                },
            });
        },
        runDelete() {
            EventBus.$emit("apiLoading", true);
            this.DeleteClass.runDelete(this.ssamTalkStepKey);
        },
        deleteAfterFunc() {
            EventBus.$emit("apiLoading", false);
            this.createAlert({
                content: "삭제가 완료되었습니다.",
                hide: () => {
                    this.viewAfterFunc();
                    if (this.directType === "modal") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit("apiLoading", false);
                        this.$modal.hide(this.directUrl);
                        return false;
                    }else {
                        this.$router.back();
                    }
                },
            });
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
